import { apiClient } from './client'

export type BrandingKind = 'logo' | 'watermark'

export const brandingApi = {
  uploadInit: async (kind: BrandingKind, fileName: string, contentType: string, idEmpresa?: number | null) => {
    const { data } = await apiClient.post('/branding/upload/init', {
      id_empresa: idEmpresa,
      kind,
      file_name: fileName,
      content_type: contentType,
    })
    return data as { upload_url: string; file_key: string; expires_in: number }
  },
  normalize: async (kind: BrandingKind, fileKey: string, idEmpresa?: number | null) => {
    const { data } = await apiClient.post('/branding/upload/normalize', {
      id_empresa: idEmpresa,
      kind,
      file_key: fileKey,
    })
    return data as { preview_url: string; file_key: string; expires_in: number }
  },
  approve: async (kind: BrandingKind, fileKey: string, idEmpresa?: number | null) => {
    const { data } = await apiClient.post('/branding/approve', {
      id_empresa: idEmpresa,
      kind,
      file_key: fileKey,
    })
    return data as { url: string; kind: BrandingKind }
  },
}
